// Port of api/fuel/app/classes/filter/template/activities.php
var TEMPLATE = {
	date: {
		from: 0,
		to: 0
	},
	members: [],
	hide: {
		status: {
			added: 0,
			removed: 0,
			own: 0,
			prevowned: 0,
			fortrade: 0,
			want: 0,
			wanttoplay: 0,
			wanttobuy: 0,
			wishlist: 0,
			preordered: 0,
			hasparts: 0,
			wantparts: 0
		},
		list: {
			added: 0,
			removed: 0
		},
		edition: {
			added: 0
		},
		member: {
			added: 0,
			removed: 0
		},
		buddy: {
			added: 0,
			removed: 0
		},
		rating: {
			added: 0,
			removed: 0,
			updated: 0
		},
		comment: {
			added: 0,
			removed: 0,
			updated: 0
		},
		collection: {
			added: 0,
			removed: 0
		},
		tags: {
			created: 0,
			deleted: 0,
			added: 0,
			removed: 0
		},
		play: {
			added: 0
		},
		hindex: 0
	}
}

function deepMerge(template, values) {
	var result = {}
	var keys = Object.keys(template)

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i]

		if (values && values[key] !== undefined) {
			if (Array.isArray(template[key])) {
				result[key] = values[key]
			} else if (template[key] !== null && typeof template[key] === 'object') {
				result[key] = deepMerge(template[key], values[key])
			} else {
				result[key] = values[key]
			}
		} else if (Array.isArray(template[key])) {
			result[key] = template[key].slice()
		} else if (template[key] !== null && typeof template[key] === 'object') {
			result[key] = deepMerge(template[key], {})
		} else {
			result[key] = template[key]
		}
	}

	return result
}

export default {
	fill: function(values) {
		return deepMerge(TEMPLATE, values || {})
	},
	session: function() { return false }
}
